import { CreateLinkedInBudgetStrategyRequest } from "../../models/linkedin-manager/strategy/CreateLinkedInBudgetStrategyRequest";
import { LinkedInBudgetStrategy } from "../../models/linkedin-manager/strategy/LinkedInBudgetStrategy";
import { BaseService } from "../BaseService";

class LinkedInStrategyManagementService extends BaseService {
    public async GetStrategiesByCompanyId(
        companyId: number | string
    ): Promise<LinkedInBudgetStrategy[]> {
        return await this.Get<LinkedInBudgetStrategy[]>(
            `/${companyId}/linkedin-strategy`
        );
    }

    public async CreateStrategy(
        companyId: number | string,
        createLinkedInBudgetStrategyRequest: CreateLinkedInBudgetStrategyRequest
    ): Promise<LinkedInBudgetStrategy> {
        return await this.Post<LinkedInBudgetStrategy>(
            `/${companyId}/linkedin-strategy`,
            createLinkedInBudgetStrategyRequest
        );
    }

    public async DeleteStrategy(
        companyId: number | string,
        id: number
    ): Promise<LinkedInBudgetStrategy> {
        return await this.Delete<LinkedInBudgetStrategy>(
            `/${companyId}/linkedin-strategy/${id}`
        );
    }
}

export const linkedinStrategyManagementService = new LinkedInStrategyManagementService("company");